import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import qs from 'qs';

import Layout from 'components/common/Layout';
import Login from 'components/account/Login';
import AccountNavigation from 'components/account/AccountNavigation';
import AccountLogo from 'components/account/AccountLogo';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import tidioSrc from 'config/tidioSrc';

class AccountLogin extends Component {
  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('page-with-tidio');
  }

  componentWillUnmount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('page-with-tidio');
  }

  render() {
    const { history } = this.props;
    const loginParams = qs.stringify({
      login: true,
    }, {
      encode: false, addQueryPrefix: true,
    });
    return (
      <Layout variant="account-login">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Log In
          </title>
          <script src={tidioSrc} async />
        </Helmet>
        <AccountLogo />
        <Login
          onSubmitSuccess={(values) => {
            if (values.auth_id) {
              //2FA variant
               history.push({
                pathname: '/account/login-confirm',
                state: {
                  auth_id: values.auth_id,
                },
              });
            } else {
              const redirectOrigin = new URL(values.url).origin;
              window.location.replace(`${redirectOrigin}${loginParams}`);
            }
          }}
        />
        <AccountNavigation />
      </Layout>
    );
  }
}

AccountLogin.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

AccountLogin.defaultProps = {
  recoverOrder: {},
};

export default AccountLogin;



// WEBPACK FOOTER //
// ./src/pages/account/AccountLogin.js